module.exports = __webpack_public_path__ + "static/media/TP6.ad664b6f.jpg";